var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSystemIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#E8EBFA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 11V12.5M12.5 16.25H11M29 16.25H27.5M12.5 20H11M29 20H27.5M12.5 23.75H11M29 23.75H27.5M16.25 27.5V29M20 11V12.5M20 27.5V29M23.75 11V12.5M23.75 27.5V29M14.75 27.5H25.25C26.4926 27.5 27.5 26.4926 27.5 25.25V14.75C27.5 13.5074 26.4926 12.5 25.25 12.5H14.75C13.5074 12.5 12.5 13.5074 12.5 14.75V25.25C12.5 26.4926 13.5074 27.5 14.75 27.5ZM15.5 15.5H24.5V24.5H15.5V15.5Z",
    stroke: "#1434CB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystemIcon);
export default __webpack_public_path__ + "static/media/system_icon.de60989173b1fc19774a1aa0835afad9.svg";
export { ForwardRef as ReactComponent };